import { Injectable } from '@angular/core';
import { MessageBusService } from './message-bus.service';

@Injectable({ providedIn: 'root' })
export class WindowManagerService {
    private windows = new Map<string, Window>();
    private contentIds = new Map<string, string>();

    constructor(private messageBus: MessageBusService) {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    private handleBeforeUnload = () => {
        
        if(this.isSecondaryWindow()) {
            this.broadcast({
                type: 'CHILD_CLOSED'
            });  
        } else {
            this.closeAllWindows();
        }
    };
    
    openOrNavigate(logicalName: string, contentId:string, url: string, windowFeatures = 'width=800,height=600') {
        const existing = this.windows.get(logicalName);
        
        if (existing && !existing.closed) {
            
            this.sendMessageToWindow(logicalName, {
                type: 'NAVIGATE',
                targetUrl: url,
            });
            existing.focus();
            this.contentIds.set(logicalName, contentId);
        } else {
            const fullUrl = `${url}?winName=${encodeURIComponent(logicalName)}`;
            const win = window.open(fullUrl, logicalName, windowFeatures);
            if (win) {
                this.windows.set(logicalName, win);
                this.contentIds.set(logicalName, contentId);
            }
        }
    }

    sendMessageToWindow(logicalName: string, payload: any): void {
        const from = sessionStorage.getItem('currentWinName') ?? 'main';
        const message = {
        ...payload,
        _from: from,
        _to: logicalName,
        _ts: Date.now(),
        };
        this.messageBus.send(message);
    }

    broadcast(payload: any): void {
        const from = sessionStorage.getItem('currentWinName') ?? 'main';
        const message = {
            ...payload,
            _from: from,
            _ts: Date.now(),
        };
        this.messageBus.send(message);
    }

    closeAllWindows(): void {
        for (const [name, win] of this.windows.entries()) {
            if (win && !win.closed) {
            win.close();
            }
        }
        this.windows.clear();
        this.contentIds.clear();
    }

    isWindowOpen(logicalName: string): boolean {
        const win = this.windows.get(logicalName);
        return !!win && !win.closed;
    }    

    getWindow(logicalName: string): Window | undefined {
        return this.windows.get(logicalName);
    }

    closeWindow(logicalName: string): void {
        const win = this.windows.get(logicalName);
        if (win && !win.closed) {
            win.close();
        }
        this.windows.delete(logicalName);
    }
    
    removeWindow(logicalName: string): void {
        this.windows.delete(logicalName);
    }    

    getOpenWindowNames(): string[] {
        const openNames: string[] = [];
        for (const [name, win] of this.windows.entries()) {
            if (win && !win.closed) {
                openNames.push(name);
            } else {
                
                this.windows.delete(name);
            }
        }
        return openNames;
    }

    getOpenContentIds(): Map<string, string> {
        const openContentIds: string[] = [];
        for (const [name, win] of this.windows.entries()) {
            if (!(win && !win.closed)) {
                this.contentIds.delete(name);
            }
        }
        return this.contentIds;
    }    

    isSecondaryWindow(): boolean {
        return !!sessionStorage.getItem('currentWinName');
    }

    getCurrentWindowName(): string | null {
        return sessionStorage.getItem('currentWinName');
    }

}
